import * as React from 'react';
import { ArticleHeading4, Button, UIText2 } from '@cian/ui-kit';

import * as styles from './styles.css';

import { EscrowLabel, ReliableLabel } from '../../../Labels';
import { SalesStartLabel } from '../../../SalesStartLabel';
import { IStatsGenplanHouse } from '../../../../types/newbuilding/genplan/StatsGenplanHouse';
import { HouseStats } from '../HouseStats';

interface IHouseTooltipProps {
  name: string;
  houseId: number;
  houseInfo: string[];
  stats?: IStatsGenplanHouse | null;
  isReliable: boolean;
  isEscrow: boolean;
  isSalesStart?: boolean;
  isFloorPlanEnabled: boolean;
  onFloorPlanClick(): void;
  onLinkClick(houseId: number, rooms?: string): void;
}

export function HouseTooltip({
  name,
  houseInfo,
  houseId,
  stats,
  isFloorPlanEnabled,
  isReliable,
  isEscrow,
  isSalesStart,
  onFloorPlanClick,
  onLinkClick,
}: IHouseTooltipProps): React.JSX.Element {
  return (
    <div className={styles['container']}>
      <ArticleHeading4>{name}</ArticleHeading4>
      {isSalesStart && (
        <div className={styles['sales-start']}>
          <SalesStartLabel />
        </div>
      )}
      <div className={styles['house-info']}>
        {houseInfo.map((item, i) => (
          <UIText2 key={item} color="gray60_100" display="inline">
            {item}
            {i < houseInfo.length - 1 ? ' • ' : ''}
          </UIText2>
        ))}
      </div>

      {(isReliable || isEscrow) && (
        <div className={styles['labels']}>
          {isReliable && <ReliableLabel light={true} />}
          {isEscrow && <EscrowLabel dark={true} />}
        </div>
      )}
      {stats && <HouseStats {...stats} houseId={houseId} onLinkClick={onLinkClick} />}
      {!stats && (
        <div className={styles['line']}>
          <UIText2>Нет квартир в продаже</UIText2>
        </div>
      )}
      {stats && isFloorPlanEnabled && (
        <div className={styles['floor-plan-button']}>
          <Button theme="fill_secondary" size="XS" fullWidth onClick={onFloorPlanClick}>
            Квартиры на этажах
          </Button>
        </div>
      )}
    </div>
  );
}
